import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";

// Matches $resolution-md / $resolution-lg in assets/scss/global/_variables.scss
const BREAKPOINTS = [
  { minWidth: 0, slidesPerView: 1 },
  { minWidth: 768, slidesPerView: 2 },
  { minWidth: 1024, slidesPerView: 3 },
];

const getCurrentSlidesPerView = () => {
  const width = window.innerWidth;
  return BREAKPOINTS.reduce(
    (slidesPerView, breakpoint) =>
      width >= breakpoint.minWidth ? breakpoint.slidesPerView : slidesPerView,
    BREAKPOINTS[0].slidesPerView,
  );
};

const destroySwiperInstance = (root) => {
  root._jsxSliderInstance?.destroy(true, true);
  delete root._jsxSliderInstance;
  delete root.dataset.slidesPerView;
  root.removeAttribute("data-initialized");
};

const evaluateJsxSlider = (root) => {
  const swiperEl = root.querySelector(".swiper");
  if (!swiperEl) return;

  const prevEl = root.querySelector(".jsx-slider__arrow--prev");
  const nextEl = root.querySelector(".jsx-slider__arrow--next");
  const scrollbarEl = root.querySelector(".jsx-slider__scrollbar");
  const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
  const slidesPerView = getCurrentSlidesPerView();

  if (slideCount <= slidesPerView) {
    if (root.hasAttribute("data-initialized")) destroySwiperInstance(root);
    root.classList.add("jsx-slider--grid");
    return;
  }

  root.classList.remove("jsx-slider--grid");

  if (
    root.hasAttribute("data-initialized") &&
    Number(root.dataset.slidesPerView) === slidesPerView
  ) {
    return;
  }

  if (root.hasAttribute("data-initialized")) destroySwiperInstance(root);

  root._jsxSliderInstance = new Swiper(swiperEl, {
    modules: [Navigation, Scrollbar],
    loop: false,
    autoHeight: true,
    spaceBetween: 16,
    slidesPerView,
    navigation: {
      nextEl,
      prevEl,
    },
    scrollbar: {
      el: scrollbarEl,
      draggable: true,
    },
  });

  root.dataset.slidesPerView = slidesPerView;
  root.setAttribute("data-initialized", "true");
};

const initJsxSliders = () => {
  document.querySelectorAll(".jsx-slider").forEach(evaluateJsxSlider);
};

const cleanupJsxSliders = () => {
  document
    .querySelectorAll(".jsx-slider[data-initialized]")
    .forEach(destroySwiperInstance);
  document
    .querySelectorAll(".jsx-slider")
    .forEach((root) => root.classList.remove("jsx-slider--grid"));
};

const safeInitJsxSliders = () => {
  try {
    cleanupJsxSliders();
    initJsxSliders();
  } catch (error) {
    console.log("Error initializing jsx sliders:", error);
  }
};

const safeEvaluateJsxSliders = () => {
  try {
    initJsxSliders();
  } catch (error) {
    console.log("Error evaluating jsx sliders:", error);
  }
};

const registerJsxSliderInit = () => {
  const run = () => setTimeout(safeInitJsxSliders, 100);

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(run);
    return;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
};

registerJsxSliderInit();

window.addEventListener("popstate", safeInitJsxSliders);

let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(safeEvaluateJsxSliders, 150);
});
